import React from "react";
import { Link, useStaticQuery, graphql } from "gatsby";
import MainNavigationItem from "./mainNavigationItem";
import Image from "../base/staticImage";
import TopBarIcons from "../icons/topBarIcons";
import Button from "../base/starButton";
import { getUrlWithCosmosCampaignParams } from "../../utilities/businessLogic";

const DesktopNavigation = ({ isDonationHeader, campaignToDonationLink, cosmosCampaignId, urlParams }) => {
  const data = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            header {
              topBar {
                icon
                text
                url
              }
              logo {
                logoImage
                title
                url
              }
            }
          }
        }
        contentfulNavigation {
          donationSlug
          navigationItems {
            title
            navigationCard {
              icon
              title
              copy
              link
            }
            subNavigations {
              title
              url
              subNavigationItems {
                title
                url
              }
            }
          }
        }
      }
    `
  );

  const { topBar, logo } = data.site.siteMetadata.header;
  const topBarLinks = topBar.map((item, index) => {
    return item.url ? (
      <li key={"topbar_index_" + index}>
        <a href={item.url} className={item.icon} title={item.icon}>
          <TopBarIcons name={item.icon} />
          {item.text}
        </a>
      </li>
    ) : (
      <li key={"topbar_index_" + index}>
        <TopBarIcons name={item.icon} />
        {item.text}
      </li>
    );
  });

  return (
    <div className="header header--desktop">
      <div className={isDonationHeader ? "hide" : "wrapper"}>
        <ul className="topbar">{topBarLinks}</ul>
      </div>
      <div className="navbar">
        <Link to={logo.url} className={"logo" + (isDonationHeader ? " disable-link" : "")} title={logo.title}>
          <Image src={logo.logoImage} />
        </Link>
        <div className={isDonationHeader ? "hide" : "navi-wrapper"}>
          <ul className="navigation">
            {data.contentfulNavigation.navigationItems.map((navItem, index) => (
              <li className="navigation--item" key={`navigation-item-li-` + index}>
                {MainNavigationItem(navItem, index)}
              </li>
            ))}
          </ul>
          <Button
            href={getUrlWithCosmosCampaignParams(campaignToDonationLink ?? data.contentfulNavigation.donationSlug, urlParams, cosmosCampaignId)}
            type="btn-donation"
            text="Donate"
          />
        </div>
      </div>
    </div>
  );
};

export default DesktopNavigation;
